// src/pages/Home.jsx
import React from 'react';
import PageWrapper from '../components/PageWrapper';

export default function Home({ role }) {
  return (
    <PageWrapper>
      <h1>Welcome to the Dashboard</h1>
      {role && (
        <p style={{ color: '#888', fontSize: '0.9rem' }}>
          Logged in as: <strong>{role}</strong>
        </p>
      )}
    </PageWrapper>
  );
}
